<template>
<v-dialog
  content-class="login-dialog"
  v-model="dialog"
  persistent
  max-width="290">
  <v-card>
    <v-img
      class="login-logo"
      height="75"
      contain
      :src="logo" />
    <v-card-title class="headline">Login</v-card-title>
      <v-form
        @submit.native="doLogin"
        v-show="!changingPassword"
        ref="loginForm"
        v-model="formValid"
        lazy-validation>
        <v-card-text>
          <v-text-field
            v-model="loginForm.username"
            :rules="requiredRules"
            label="Username"
            required
          ></v-text-field>
          <v-text-field
            v-model="loginForm.password"
            type="password"
            :rules="requiredRules"
            label="Password"
            required
          ></v-text-field>
          <v-alert
            :value="errorMsg"
            color="error"
            icon="mdi-alert-decagram"
            outline
          >
            {{ errorMsg }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            color="green darken-1" flat @click="doLogin">Login</v-btn>
        </v-card-actions>
      </v-form>
      <v-form
        @submit.native="doChangePassword"
        ref="changePasswordForm"
        v-model="formChangePasswordValid"
        v-show="changingPassword"
        lazy-validation>
        <v-card-text>
        <v-text-field
          v-model="changePasswordForm.newPassword"
          type="password"
          :rules="requiredRules"
          label="Nuova password"
          required
        ></v-text-field>
        <v-text-field
          v-model="changePasswordForm.confirm"
          type="password"
          :rules="requiredRules"
          label="Conferma password"
          required
        ></v-text-field>
        <v-alert
          :value="errorMsg"
          color="error"
          icon="mdi-alert-decagram"
          outline
        >
          {{ errorMsg }}
        </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            color="green darken-1" flat @click="doChangePassword">
            Cambia password e Login
          </v-btn>
        </v-card-actions>
      </v-form>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  name: 'login-modal',
  data() {
    const that = this;
    return {
      logo: require('@/assets/tcloud-logo.png'), //eslint-disable-line
      dialog: false,
      formValid: false,
      formChangePasswordValid: false,
      loginForm: {
        username: null,
        password: null,
      },
      changePasswordForm: {
        newPassword: null,
        confirm: null,
      },
      requiredRules: [
        v => !!v || 'Campo obbligatorio',
        () => (that.changePasswordForm.newPassword === that.changePasswordForm.confirm) || 'Le password non coincidono',
      ],
      errorMsg: null,
      errorMsgTimeout: null,
      changingPassword: false,
    };
  },
  watch: {
    loggedIn: {
      immediate: true,
      handler() {
        this.dialog = !this.loggedIn;
      },
    },
    dialog: {
      handler() {
        if (this.dialog) {
          this.$nextTick(() => {
            document
              .querySelector('.application--wrap')
              .classList.add('blurred');
          });
        } else {
          this.$nextTick(() => {
            document
              .querySelector('.application--wrap')
              .classList.remove('blurred');
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    async doLogin(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.errorMsgTimeout) clearTimeout(this.errorMsgTimeout);
      if (this.$refs.loginForm.validate()) {
        const result = await this.login(this.loginForm);
        if (result === false) {
          this.changingPassword = true;
          return;
        }

        if (result !== true) {
          this.errorMsg = result;
          this.errorMsgTimeout = setTimeout(() => { this.errorMsg = null; }, 2000);
        } else {
          this.setSnackbar({ type: 'INFO', msg: 'Login effettuato!' });
        }

        this.$refs.loginForm.reset();
      }
    },
    async doChangePassword(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.errorMsgTimeout) clearTimeout(this.errorMsgTimeout);
      if (this.$refs.changePasswordForm.validate()) {
        const done = await this.changePassword({
          ...this.loginForm,
          ...this.changePasswordForm,
        });
        if (done) this.setSnackbar({ type: 'INFO', msg: 'Password modificata con successo' });
        else this.setSnackbar({ type: 'ERROR', msg: 'Errore nel cambio di password' });
        this.changingPassword = false;
        this.$refs.changePasswordForm.reset();
      }
    },
  },
};
</script>
